module.exports = __webpack_public_path__ + "img/experience.26f07e41.svg";